import React, { type ReactNode } from 'react';
import { getClassNames } from '../../helpers/classHelpers';
import style from './Hero.module.scss';

type Props = {
    mainContent?: ReactNode;
    sideContent?: ReactNode;
};

const Hero: React.FC<Props> = ({ mainContent, sideContent }) => {
    return (
        <>
            <div className={style.heroLayout}>
                <div id="hero1" className={style.heroPrimary}>
                    <div style={{ flex: 1, paddingTop: '5rem' }} className={getClassNames([style.hero, 'df-hero-card'])}>
                        <section className='df-container'>
                            <div>
                                {mainContent && <div className='main-content'>
                                    {mainContent}
                                </div>}
                                {sideContent && <div className='side-content'>
                                    {sideContent}
                                </div>}
                            </div>
                        </section>
                    </div>
                    <div style={{ height: 'auto' }} className={getClassNames([style.imageHero, 'df-hero-card'])}>
                    </div>
                </div>
                {/* <div id="hero2" className={style.heroSecondary} style={{ margin: '1rem 0' }}>
                    {<ol className={style.steps}>
                        <li className={style.step}>
                            <span className={style.number}>Step 1</span>
                            <h5>Ask a question</h5>
                            <p>Ask questions about PLUS+1 products, technical features or troubleshooting.</p>
                        </li>
                        <li className={style.step}>
                            <span className={style.number}>Step 2</span>
                            <h5>Find relevant answers</h5>
                            <p>Get clear answers with references to relevant Danfoss documentation.</p>
                        </li>
                        <li className={style.step}>
                            <span className={style.number}>Step 3</span>
                            <h5>Get additional support</h5>
                            <p>Continue the conversation or create a support case if you need further assistance.</p>
                        </li>
                    </ol>}
                </div> */}
            </div>
        </>
    );
};

export default Hero;
